import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { 
  Star, 
  BadgeCheck, 
  Ban, 
  FileText, 
  Luggage, 
  ShieldCheck, 
  Umbrella, 
  Headset, 
  CalendarDays 
} from 'lucide-react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import './travelInsuredHome.css';
import Nav from '../NavBar/Nav';
import FooterNew from '../NavBar/FooterNew';
import { useNavigate } from 'react-router-dom';

const TravelInsuredHome = () => {

    const navigate = useNavigate()
    return (
      <div>
             <Nav />
      
    <div className="landing-page">
      {/* SECTION 1: HERO */}
      <section className=" travel-wrapper">
        <div className="hero-banner">
          <div className="hero-content">
            <h1>Travel Protection That Meets You In The Moment</h1>
            <p>Get your custom travel protection quote and journey carefree.</p>
                            <button className="btn-primary" onClick={() => {
                                navigate('/book-quote')
            }}>GET A QUOTE</button>
            <a href="#" className="hero-link">Explore the Annual Multi-Trip Protector Plan &rarr;</a>
                            <div className="hero-logo-mock">
            <img src="https://cdn.prod.website-files.com/688bd807419a7258087bc0d9/68a621ccb5ae358dfe97480e_Travel-insured-logo.svg" alt="Traveler" />
                                
            </div>
          </div>
          <div className="hero-image">
            <img src="https://cdn.prod.website-files.com/688bd807419a7258087bc0d9/688d21a7cf4ebc19a6509fc6_Travel%20Insured%20internationa%20banner%20main5.avif" alt="Traveler" />
          </div>
        </div>
      </section>

      {/* SECTION 2: REVIEWS (SWIPER) */}
      <section className="reviews-section travel-wrapper">
        <div className="reviews-summary">
          <h2>Great</h2>
          <div className="stars">
            {[...Array(5)].map((_, i) => <Star key={i} fill="#00b67a" color="#00b67a" size={24} />)}
          </div>
          <p>Based on <strong>2,208 reviews</strong></p>
          <div className="trustpilot-mock">
            <Star fill="#00b67a" color="#00b67a" size={20} /> Trustpilot
          </div>
        </div>

        <div className="reviews-slider">
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            breakpoints={{
              640: { slidesPerView: 2 },
              960: { slidesPerView: 3 },
              1200: { slidesPerView: 4 }
            }}
          >
            {reviewsData.map((review, idx) => (
              <SwiperSlide key={idx}>
                <div className="review-card">
                  <div className="review-stars-row">
                    <div className="stars small">
                      {[...Array(5)].map((_, i) => <Star key={i} fill="#00b67a" color="#00b67a" size={14} />)}
                    </div>
                    <span className="verified"><BadgeCheck size={14} /> Verified</span>
                  </div>
                  <p className="review-meta"><strong>{review.name}</strong>, {review.time}</p>
                  <h4 className="review-title">{review.title}</h4>
                  <p className="review-text">{review.text}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* SECTION 3: BENEFITS */}
      <section className="benefits-section">
        <div className="travel-wrapper">
          <h2 className="section-title white">Our Travel Insurance Benefits Can Include*</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon"><Ban size={48} color="#00b67a" /></div>
              <h3 className="benefit-title">Trip & Flights Cancellation</h3>
              <p>Trip cancellation and interruption insurance coverages that can reimburse for covered losses caused by inclement weather, natural disaster, strike, illness, traffic accident, and job reasons.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon"><FileText size={48} color="#00b67a" /></div>
              <h3 className="benefit-title">Medical Expense Coverage</h3>
              <p>Insurance coverages that can reimburse for covered losses caused by accident, sickness, evacuation, and pre-existing medical conditions (when waiver eligibility requirements are met).</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon"><Luggage size={48} color="#00b67a" /></div>
              <h3 className="benefit-title">Baggage Delay & Loss</h3>
              <p>Coverages that can reimburse for covered losses caused by baggage delay, loss and theft.</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: WHY US */}
      <section className="why-us-section travel-wrapper">
        <h2 className="section-title dark" style={{textAlign:'center'}}>Why Travel Insured International</h2>
        <p className="section-subtitle">When choosing travel protection, your peace of mind matters most. Here's what sets us apart:</p>
        
        <div className="why-us-grid">
          <div className="why-card">
            <div className="why-icon-container"><ShieldCheck size={32} color="#fff" /></div>
            <h3>30+ Years of Trusted Experience</h3>
            <p>Trusted by travelers for over three decades, we bring the experience to protect your adventures.</p>
          </div>
          <div className="why-card">
            <div className="why-icon-container"><Umbrella size={32} color="#fff" /></div>
            <h3>Extensive Travel Coverage</h3>
            <p>From cancellations to medical emergencies, our coverage can help keep you prepared for the unexpected.</p>
          </div>
          <div className="why-card">
            <div className="why-icon-container"><Headset size={32} color="#fff" /></div>
            <h3>24/7 Global Support</h3>
            <p>Get round-the-clock non-insurance assistance services anywhere in the world with just one call to our expert care team.</p>
          </div>
          <div className="why-card">
            <div className="why-icon-container"><CalendarDays size={32} color="#fff" /></div>
            <h3>14-Day Free Look Period</h3>
            <p>You can cancel your plan within 14 days for a full refund if no claims or travel have occurred (coverage will be void once cancelled).</p>
          </div>
        </div>
      </section>
            </div>
            
            <FooterNew/>
            </div>
  );
};

// --- Mock Data ---
const reviewsData = [
  {
    name: "CCinAZ",
    time: "11 hours ago",
    title: "Happy customer",
    text: "Although it took about a month for the claim to be processed we were sent a chec..."
  },
  {
    name: "Richard Olmstead",
    time: "1 day ago",
    title: "Peace of Mind",
    text: "The best thing about the insurance was I didn't need it - but I had the peace of..."
  },
  {
    name: "Charles Thuma",
    time: "2 days ago",
    title: "Fast and easy",
    text: "Fast and easy"
  },
  {
    name: "Micheal",
    time: "2 days ago",
    title: "Piece of Mind",
    text: "Piece of Mind"
  }
];

export default TravelInsuredHome;